// extracted by mini-css-extract-plugin
export var border = "_21-8";
export var brand = "_21-t";
export var button = "_21-l";
export var center = "_21-a";
export var centered = "_21-6";
export var closeButton = "_21-c";
export var disabledWrapper = "_21-m";
export var error = "_21-p";
export var extraLarge = "_21-4";
export var extraSmall = "_21-1";
export var fill = "_21-i";
export var footer = "_21-h";
export var footerAction = "_21-j";
export var footerButtons = "_21-k";
export var header = "_21-7";
export var headerWithClose = "_21-d";
export var icon = "_21-o";
export var info = "_21-s";
export var inline = "_21-9";
export var large = "_21-3";
export var main = "_21-e";
export var modal = "_21-0";
export var nearFull = "_21-5";
export var neutral = "_21-u";
export var noPadding = "_21-g";
export var none = "_21-v";
export var scrollable = "_21-f";
export var small = "_21-2";
export var success = "_21-r";
export var tight = "_21-n";
export var titleIcon = "_21-b";
export var warn = "_21-q";